/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorTiktok from 'base/components/labrador/Tiktok';

export const DynamicLabradorTiktok: typeof LabradorTiktok = (props) => {
    return <ErrorBoundary><LabradorTiktok {...props} /></ErrorBoundary>;
}
export type DynamicLabradorTiktokProps = PropsFromComponent<typeof LabradorTiktok>;
